import { AdminHomeCard, AdminHomeCardGroup, AdminHomeCardGroups } from "../../../admin/components/AdminHomeCard"
import { LocalizedStrict } from "../../../localization/components/AppLocalized"
import {
    COMPANY_ADMIN_ACCOUNT_ADMINS_ROUTE,
    COMPANY_ADMIN_ACCOUNT_GDPR_ROUTE,
    COMPANY_ADMIN_ACCOUNTING_BILL_RECEIVERS_ROUTE,
    COMPANY_ADMIN_ORGANIZATION_DEPARTMENTS_ROUTE,
    COMPANY_ADMIN_ORGANIZATION_LOCATIONS_ROUTE,
    COMPANY_ADMIN_ORGANIZATION_USER_GROUPS_ROUTE,
    COMPANY_ADMIN_ORGANIZATION_USERS_ROUTE,
} from "../../../../constants/routes"
import { makeStyles } from "tss-react/mui"
import { useNavigate } from "react-router-dom"
import { useMatchEnvironment } from "../../../environment/envHooks"
import { EnvironmentType } from "../../../environment/envTypes"
import { CompanyComingSoonPlaceholder } from "../../components/CompanyComingSoonPlaceholder"

const useStyles = makeStyles()((_theme) => ({
    page: {
        paddingTop: "3rem",
    },
}))

type Props = Readonly<{}>

export function CompanyAdminHome({}: Props) {
    const { classes } = useStyles()
    const navigate = useNavigate()
    const isComingSoon = useMatchEnvironment([EnvironmentType.Prod])

    if (isComingSoon) {
        return <CompanyComingSoonPlaceholder />
    }

    return (
        <div className={classes.page}>
            <AdminHomeCardGroups>
                <LocalizedStrict id="company-organization-title" attrs={{ title: true }}>
                    <AdminHomeCardGroup title="Organization">
                        <LocalizedStrict
                            id="company-admin-home-organization-users-card"
                            attrs={{ title: true, description: true }}
                        >
                            <AdminHomeCard
                                title="Users"
                                description="Manage users"
                                onShowAllClick={() => navigate(COMPANY_ADMIN_ORGANIZATION_USERS_ROUTE)}
                            />
                        </LocalizedStrict>
                        <LocalizedStrict
                            id="company-admin-home-organization-bill-receivers-card"
                            attrs={{ title: true, description: true }}
                        >
                            <AdminHomeCard
                                title="Bill receivers"
                                description="Manage bill receivers"
                                onShowAllClick={() => navigate(COMPANY_ADMIN_ACCOUNTING_BILL_RECEIVERS_ROUTE)}
                            />
                        </LocalizedStrict>
                        <LocalizedStrict
                            id="company-admin-home-organization-user-group-card"
                            attrs={{ title: true, description: true }}
                        >
                            <AdminHomeCard
                                title="User groups"
                                description="Manage user groups"
                                onShowAllClick={() => navigate(COMPANY_ADMIN_ORGANIZATION_USER_GROUPS_ROUTE)}
                            />
                        </LocalizedStrict>
                        <LocalizedStrict
                            id="company-admin-home-organization-departments-card"
                            attrs={{ title: true, description: true }}
                        >
                            <AdminHomeCard
                                title="Departments"
                                description="Manage departments"
                                onShowAllClick={() => navigate(COMPANY_ADMIN_ORGANIZATION_DEPARTMENTS_ROUTE)}
                            />
                        </LocalizedStrict>
                        <LocalizedStrict
                            id="company-admin-home-organization-locations-card"
                            attrs={{ title: true, description: true }}
                        >
                            <AdminHomeCard
                                title="Locations"
                                description="Manage locations"
                                onShowAllClick={() => navigate(COMPANY_ADMIN_ORGANIZATION_LOCATIONS_ROUTE)}
                            />
                        </LocalizedStrict>
                    </AdminHomeCardGroup>
                </LocalizedStrict>
                <LocalizedStrict id="company-nav-item-account-title" attrs={{ title: true }}>
                    <AdminHomeCardGroup title="Account">
                        <LocalizedStrict
                            id="company-admin-home-account-gdpr-card"
                            attrs={{ title: true, description: true, buttonText: true }}
                        >
                            <AdminHomeCard
                                title="GDPR"
                                description="General Data Protection Regulation"
                                buttonText="Show"
                                onShowAllClick={() => navigate(COMPANY_ADMIN_ACCOUNT_GDPR_ROUTE)}
                            />
                        </LocalizedStrict>
                        <LocalizedStrict
                            id="company-admin-home-account-administrator-card"
                            attrs={{ title: true, description: true }}
                        >
                            <AdminHomeCard
                                title="Administrators"
                                description="Manage administrators"
                                onShowAllClick={() => navigate(COMPANY_ADMIN_ACCOUNT_ADMINS_ROUTE)}
                            />
                        </LocalizedStrict>
                    </AdminHomeCardGroup>
                </LocalizedStrict>
            </AdminHomeCardGroups>
        </div>
    )
}
